<p>product-detail works!</p>
